import { create } from "zustand/react";
import ContractSortTypeEnum from "@/constants/enums/ContractSortTypeEnum";
import ContractStatusEnum from "@/constants/enums/ContractStatusEnum";

type ContractState = {
  currentPage: number;
  numberOfPages: number;
  limit: number;
  sortOption: ContractSortTypeEnum; // If null sorting by ID;
  sortDirection: "ASC" | "DESC";
  setPage: (page: number) => void;
  setNumberOfPages: (numberOfPages: number) => void;
  setLimit: (limit: number) => void;
  setSortOption: (option: ContractState["sortOption"]) => void;
  setSortDirection: (direction: ContractState["sortDirection"]) => void;
  showListAsGrid: boolean;
  setShowListAsGrid: (showListAsGrid: boolean) => void;
  statuses: ContractStatusEnum[];
  setContractStatuses: (statuses: ContractStatusEnum[]) => void;
  query: string;
  setQuery: (query: string) => void;
  reset: () => void;
};

export const useContractStore = create<ContractState>((set, _) => ({
  currentPage: 1,
  numberOfPages: 0,
  limit: 30,
  sortOption: ContractSortTypeEnum.BY_DATE,
  query: "",
  setQuery: (query) => set({ query }),
  sortDirection: "DESC",
  setPage: (page) => set({ currentPage: page }),
  setNumberOfPages: (numberOfPages) => set({ numberOfPages }),
  setLimit: (limit) => set({ limit }),
  setSortOption: (option) => set({ sortOption: option }),
  setSortDirection: (direction) => set({ sortDirection: direction }),
  showListAsGrid: false,
  setShowListAsGrid: (showListAsGrid) => set({ showListAsGrid }),
  statuses: [],
  setContractStatuses: (statuses: ContractStatusEnum[]) => set({ statuses: statuses }),
  reset: () =>
    set({
      currentPage: 1,
      // numberOfPages: 0,
      limit: 30,
    }),
}));
